module.exports = __webpack_public_path__ + "img/completion4.a4f782f8.svg";